import { RemotePresignedFile } from '@gem/modules/remote-storage';
import { VideoPlayerType } from '@gem/ui-kit';

import Entities from 'STORE';

interface IInitVideoPlayer {
  container: HTMLDivElement;
  url: string;
  previewUrl: string | null;
  type?: VideoPlayerType;
  onExpandMini: (() => void) | null;
  onShowMini: (() => void) | null;
}

export function initVideoPlayer({
  container,
  url,
  type = VideoPlayerType.Default,
  previewUrl = null,
  onExpandMini = null,
  onShowMini = null,
}: IInitVideoPlayer): void {
  const globalVideoPlayer = Entities.GlobalVideoPlayer;
  const videoFile = new RemotePresignedFile();
  videoFile.url = url;

  videoFile.onload = (): void => {
    globalVideoPlayer.setUrl(videoFile.presignedUrl);
  };

  globalVideoPlayer.setPreviewUrl(previewUrl);
  globalVideoPlayer.setExpandMiniHandler(onExpandMini);
  globalVideoPlayer.setShowMiniHandler(onShowMini);
  globalVideoPlayer.setContainer(container);
  globalVideoPlayer.setType(type);
  globalVideoPlayer.setContainer(container);
  globalVideoPlayer.setType(type);
  globalVideoPlayer.setPreviewUrl(previewUrl);
  globalVideoPlayer.setExpandMiniHandler(onExpandMini);
  globalVideoPlayer.setShowMiniHandler(onShowMini);
}
